import { Pill, type PillSize, type PillVariant } from "@clipboard-health/ui-components";

interface TierShiftPillProps {
  size?: PillSize;
  variant?: PillVariant;
  compact?: boolean;
}

export function TierShiftPill(props: TierShiftPillProps) {
  const { size = "small", variant = "outlined", compact = false } = props;

  return (
    <Pill
      variant={variant}
      size={size}
      label={compact ? undefined : "\u00A0Gold"}
      iconType="membership-gold-colored"
      backgroundColor={(theme) => theme.palette.background.tertiary}
      color={(theme) => theme.palette.tiers?.gold.text}
      iconColor={(theme) => theme.palette.tiers?.gold.text}
      outlineColor={(theme) => theme.palette.tiers?.gold.text}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
